import { localeToBcp47 } from '@/lib/seo/hreflang';

/**
 * Format an order date for display in the user's locale.
 */
export function formatOrderDate(dateStr: string, locale: string): string {
  const intlLocale = localeToBcp47(locale);
  return new Intl.DateTimeFormat(intlLocale || 'en-GB', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  }).format(new Date(dateStr));
}
